/**
 * User: n.gorte
 * Date: 06.11.2020
 * Time: 12:30
 */

import React from 'external/react';

export const HtmlTextRenderer = ({text}) => {

    if (text==='<p><br></p>'){
        text=undefined;
    }

    return (
        <span dangerouslySetInnerHTML={{ __html: text || '---' }}/>
    );
};



// WEBPACK FOOTER //
// ./js/components/ChangeRecords/HtmlTextRenderer.js